module.exports = __webpack_public_path__ + "static/img/GoldenMiner.775be479.png";